// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 2,
  argument: "The advantages of wisdom: and the evils from which it delivers.",
  verses: [
    { n: 1, text: "My son, if thou wilt receive my words, and wilt hide my commandments with thee," },
    { n: 2, text: "That thy ear may hearken to wisdom: incline thy heart to know prudence." },
    { n: 3, text: "For if thou shalt call for wisdom, and incline thy heart to prudence:" },
    { n: 4, text: "If thou shalt seek her as money, and shalt dig for her as for a treasure:" },
    { n: 5, text: "Then shalt thou understand the fear of the Lord, and shalt find the knowledge of God:" },
    { n: 6, text: "Because the Lord giveth wisdom: and out of his mouth cometh prudence and knowledge." },
    { n: 7, text: "He will keep the salvation of the righteous, and protect them that walk in simplicity," },
    { n: 8, text: "Keeping the paths of justice, and guarding the ways of saints." },
    { n: 9, text: "Then shalt thou understand justice, and judgment, and equity, and every good path." },
    { n: 10, text: "If wisdom shall enter into thy heart, and knowledge please thy soul:" },
    { n: 11, text: "Counsel shall keep thee, and prudence shall preserve thee," },
    { n: 12, text: "That thou mayst be delivered from the evil way, and from the man that speaketh perverse things:" },
    { n: 13, text: "Who leave the right way, and walk by dark ways:" },
    { n: 14, text: "Who are glad when they have done evil, and rejoice in the most wicked things:" },
    { n: 15, text: "Whose ways are perverse, and their steps infamous." },
    { n: 16, text: "That thou mayst be delivered from the strange women, and from the stranger, who softeneth her words;" },
    { n: 17, text: "And forsaketh the guide of her youth," },
    { n: 18, text: "And hath forgotten the covenant of her God: for her house inclineth unto death, and her paths to hell." },
    { n: 19, text: "None that go in unto her, shall return again, neither shall they take hold of the paths of life." },
    { n: 20, text: "That thou mayst walk in a good way: and mayst keep the paths of the just." },
    { n: 21, text: "For they that are upright, shall dwell in the earth; and the simple shall continue in it." },
    { n: 22, text: "But the wicked shall be destroyed from the earth: and they that do unjustly, shall be taken away from it." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "If. This proves free will. To become truly wise, we must desire it with the same avidity as a miser seeks for riches. (Worthington) — We must also pray, (", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: ") with humility (", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: ") to God, the giver of wisdom,", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Every science which has not Him for the beginning and end, is vain and dangerous.", attribution: "Calmet" }
    ] },
    { verse: 7, notes: [
      { text: "Salvation. Protestants, \"sound wisdom.\" Tushiya (Haydock) often occurs in this book, and is very comprehensive, (Calmet) denoting the substance (Haydock) of goodness, virtue, &c., Job v. 12.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Justice. In his servants. (Calmet) — God gives them grace to follow virtue, (Haydock) and protects them from every danger.", attribution: "Calmet" }
    ] },
    { verse: 12, notes: [
      { text: "Things. The danger of such company for young people is very great, as the heart is misled by the understanding, (Calmet) if it do not itself shew the way to error. (Haydock) — We all possess a fund of corruption.", attribution: "Calmet" }
    ] },
    { verse: 14, notes: [
      { text: "Evil. These signs prove whom we ought to shun. St. Augustine depicts his own conduct before his conversion in the darkest colours.", attribution: "Calmet" }
    ] },
    { verse: 16, notes: [
      { text: "Strange. Idolatress, (Grotius) or rather the abandoned woman, whether married or not. (Calmet) — This description, as well as the former, guards us against heretics, who leave the right way of the Catholic Church, (", attribution: "Haydock" }
    ] },
    { verse: 13, notes: [
      { text: ") and devise perverse doctrines of rebellion against princes, &c., as if faith alone were sufficient. By this faith, Protestants do not mean any article which all must believe, but only that each one must be convinced that he himself is just, and will be saved. Like the strange woman, they preach a comfortable doctrine, and use sweet speeches, Romans xvi. 18. Their conversion is a very difficult matter, (", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: ") because they are condemned by their own judgment, (Titus iii. 11.) and will not admit of the ordinary means of instruction in the Church.", attribution: "Worthington" }
    ] },
    { verse: 17, notes: [
      { text: "Youth. Her husband, whom she married young when love is more lasting. This increases her guilt. It may also signify her father, or preceptor.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "God. The law forbids adultery, and all impurities, Deuteronomy xxiii. 17., and Leviticus xx. 10. Both the parties, guilty of adultery, were punished with death.", attribution: "Calmet" }
    ] },
    { verse: 21, notes: [
      { text: "Earth. Happily. This was the wish of the carnal Jews. But the more enlightened raise their thoughts to heaven.", attribution: "Haydock" }
    ] },
  ],
};

export default chapter;
